import { BaseApiService } from '@/shared/api/services/base.service';
import type { UpscaleStatusType } from '@/shared/constants/status';
import type { ApiResponse } from '@/types/api';

export interface UpscaleRenderResponse {
  id: string;
  type: 'job';
  attributes: {
    job_id: string;
    estimated_completion_time: number;
    status: UpscaleStatusType;
  };
}

export interface RenderUpscaleStatus {
  id: string;
  type: 'render';
  attributes: {
    id: string;
    is_upscaled: boolean;
    file_url: string;
    upscaled_at?: string;
  };
}

class UpscaleService extends BaseApiService {
  async upscaleRender(
    renderId: string
  ): Promise<ApiResponse<UpscaleRenderResponse>> {
    return this.post(
      `/v1/renders/${renderId}/upscale`,
      this.formatJsonApiData('upscale', {})
    );
  }

  async getUpscaleStatus(
    renderId: string
  ): Promise<ApiResponse<RenderUpscaleStatus>> {
    return this.httpGet(`/v1/renders/${renderId}`);
  }
}

export const upscaleApi = new UpscaleService();
